export default __webpack_public_path__ + "static/media/bernygroup2b.b76669d4.jpg";